<script lang="ts" setup>
import { __ } from '@@/bits/intl'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import OzInput from '@@/library/v4/components/OzInput.vue'
import OzLabelInput from '@@/library/v4/components/OzLabelInput.vue'
import OzLoadingText from '@@/library/v4/components/OzLoadingText.vue'
import OzTextButton, { OzTextButtonColorScheme } from '@@/library/v4/components/OzTextButton.vue'
import { useLtiStore } from '@@/pinia/lti_store'
import { computed } from 'vue'

const ltiStore = useLtiStore()

const isTokenValid = computed((): 'yes' | 'no' => {
  return ltiStore.tokenValidationMessage.length ? 'no' : 'yes'
})

const isLoginWithTokenButtonDisabled = computed((): boolean => {
  return !ltiStore.linkDeploymentToken.length || !!ltiStore.tokenValidationMessage.length
})

function onInputTokenInput(e): void {
  ltiStore.setLinkDeploymentToken(e.target.value)
  // Reset the token validation message to enable the Login button when typing on mobile and tablet
  if (ltiStore.tokenValidationMessage.length) ltiStore.setTokenValidationMessage('')
}
</script>

<template>
  <form novalidate class="flex flex-col" @submit.prevent="ltiStore.loginWithToken">
    <OzLabelInput class="mb-4">
      <template #label>
        <label
          for="token-input"
          :class="['text-body-small-posts', 'text-dark-text-100 dark:text-light-text-100', 'px-2']"
        >
          {{ __('LTI Link Deployment Token') }}
        </label>
      </template>

      <template #input
        ><OzInput
          id="token-input"
          name="token"
          type="text"
          test-id="tokenInput"
          :disabled="ltiStore.isAwaitingServerResponse"
          :model-value="ltiStore.linkDeploymentToken"
          :validation-message="ltiStore.tokenValidationMessage"
          :valid="isTokenValid"
          class="bg-light-ui-100 dark:bg-dark-ui-100"
          @input="onInputTokenInput"
      /></template>
    </OzLabelInput>
    <p
      class="flex items-center justify-center tablet-portrait:justify-start px-2 text-body-small-posts text-dark-text-200 dark:text-light-text-200 mb-4"
    >
      <OzTextButton
        :href="ltiStore.dashboardSettingsUrl"
        target="_blank"
        :color-scheme="OzTextButtonColorScheme.Secondary"
        :text="__('Get token')"
        class="!underline font-semibold"
      />
    </p>
    <div class="flex justify-center tablet-portrait:justify-end">
      <OzLoadingText
        v-if="ltiStore.isAwaitingServerResponse"
        :text="__('Logging in...')"
        class="text-heading-4 text-center font-semibold px-5 py-2"
      />
      <OzContainedButton
        v-else
        :color-scheme="OzContainedButtonColorScheme.Primary"
        :disabled="isLoginWithTokenButtonDisabled"
        class="w-full tablet-portrait:w-auto"
        >{{ __('Log in to connect') }}</OzContainedButton
      >
    </div>
  </form>
</template>
